// extracted by mini-css-extract-plugin
module.exports = {"answers":"azeofxKOzIre2CIrSaEnAg=="};